export const ROUTES = {
  LOGIN: '/login',
  LOGOUT: '/logout',
  HOME: '/',
  ERROR_403: '/error/403',
  ERROR_500: '/error/500',
  IMAGE: 'image',

  /* Orders */
  ORDER_LIST: '/orders/list',
  ORDERS_ITEM_DETAIL: '/orders/item/:id',
  ORDER_DETAIL_PAGE: '/orders/online/:id',
  OFFLINE_ORDER_DETAIL_PAGE: '/orders/offline/:id',
}
